import { Observable } from 'rxjs';
import { Actions } from '../../actions';
import { GetEarningsExportUrlSuccess } from '../action-creators';
import { GET_EARNINGS_EXPORT_URL_SUCCESS } from '../actions';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { NoOp } from '@webapp/store/ui/action-creators';

export const successGetEarningsExportUrlEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, GetEarningsExportUrlSuccess>(
      GET_EARNINGS_EXPORT_URL_SUCCESS
    ),
    map((action) => {
      window.location.assign(action.url);
      return new NoOp();
    })
  );
